import React, { ReactNode } from 'react';
import { ReactRouterTextButton } from '@uds/react-router-adapter';
import { useIsExternalRoute } from 'domain/selectors/common';

interface OuterProps {
  href: string;
  children?: ReactNode;
}

const PureLink = ({ href, children }: OuterProps) => {
  const [isExternalRoute, route] = useIsExternalRoute(href);

  return (
    <ReactRouterTextButton isExternalRoute={isExternalRoute} href={route}>
      {children}
    </ReactRouterTextButton>
  );
};

PureLink.displayName = 'LegalDocumentLink';

export default PureLink;
